module.exports = __webpack_public_path__ + "static/media/empty.bbbc2374.svg";